
(function(){
  /* window.brfVoice(input, beforeEl): puts a microphone before beforeEl; speaking fills the search box live
     (so the suggestions follow along) and then searches. Hidden where the browser can't do speech. */
  var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  window.brfVoice = function(input, before){
    if (!SR || !input || !before || input.__brfMic) return null;
    input.__brfMic = true;
    var form = input.form, btn = document.createElement('button'), rec = null, on = false, heard = '', phT = 0, goT = 0, ph = input.placeholder;
    btn.type = 'button'; btn.className = 'brf-mic'; btn.setAttribute('aria-label', 'Search by voice'); btn.setAttribute('aria-pressed', 'false');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect class="brf-mic__cap" x="9" y="3" width="6" height="11" rx="3"/><path d="M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21M8.5 21h7"/></svg>';
    before.parentNode.insertBefore(btn, before);
    function say(t, ms){
      clearTimeout(phT);
      if (!input.__brfPh) input.__brfPh = input.placeholder;
      input.placeholder = t;
      if (ms) phT = setTimeout(function(){ input.placeholder = input.__brfPh || ph; input.__brfPh = null; }, ms);
    }
    function fill(v){
      input.value = v;
      try { input.dispatchEvent(new Event('input', {bubbles: true})); } catch (e) {}
    }
    function done(){
      on = false; btn.classList.remove('is-listening'); btn.setAttribute('aria-pressed', 'false'); btn.setAttribute('aria-label', 'Search by voice');
    }
    function stop(){ if (rec && on) { try { rec.stop(); } catch (e) {} } }
    function start(){
      clearTimeout(goT); heard = '';
      rec = new SR(); rec.lang = 'en-GB'; rec.interimResults = true; rec.maxAlternatives = 1; rec.continuous = false;
      rec.onresult = function(e){
        var fin = '', mid = '';
        for (var i = 0; i < e.results.length; i++) { if (e.results[i].isFinal) fin += e.results[i][0].transcript; else mid += e.results[i][0].transcript; }
        fill((fin || mid).replace(/[.!?]+$/, '').trim());
        if (fin) heard = input.value;
      };
      rec.onerror = function(e){
        if (e.error === 'not-allowed' || e.error === 'service-not-allowed') say('Your microphone is blocked. Allow it in your browser to search by voice', 4500);
        else if (e.error === 'no-speech') say('Didn’t catch that! Tap the mic and try again 🎙️', 3500);
        else if (e.error !== 'aborted') say('Voice search had a wobble. Please type instead', 3500);
      };
      rec.onend = function(){
        done();
        if (heard) {
          say('Searching for “' + heard + '” ✨', 2500);
          /* a moment to see what was heard (and the live suggestions), then off we go */
          goT = setTimeout(function(){ if (input.value.trim() !== heard) return; if (form && form.requestSubmit) form.requestSubmit(); else if (form) form.submit(); }, 900);
        } else if (input.placeholder.indexOf('Listening') === 0) { say(input.__brfPh || ph, 0); input.__brfPh = null; }
      };
      try { rec.start(); } catch (e) { done(); return; }
      on = true; btn.classList.add('is-listening'); btn.setAttribute('aria-pressed', 'true'); btn.setAttribute('aria-label', 'Stop listening');
      say('Listening… tell us a fabric, colour or project 🎙️');
    }
    btn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); if (on) stop(); else start(); });
    /* typing takes over from the microphone */
    input.addEventListener('keydown', function(){ clearTimeout(goT); if (on) { try { rec.abort(); } catch (e) {} } });
    return {btn: btn, stop: function(){ clearTimeout(goT); if (on) { try { rec.abort(); } catch (e) {} } }};
  };
  /* the full header's search bar (every screen size) */
  function mainBar(){
    var f = document.querySelector('#shopify-section-header form.search-bar'), i = f && f.querySelector('.search-bar__input'), w = i && i.closest('.search-bar__input-wrapper');
    if (w && w.nextElementSibling) window.brfVoice(i, w.nextElementSibling);
    else if (w) { var x = document.createElement('span'); w.parentNode.appendChild(x); window.brfVoice(i, x); }
  }
  /* 2026-10-24: loaded straight after the header search form, so the mic is drawn with the bar instead of popping in later */
  if (document.querySelector('#shopify-section-header form.search-bar .search-bar__input') || document.readyState !== 'loading') mainBar(); else document.addEventListener('DOMContentLoaded', mainBar);
})();
